export class LoadedData {
    constructor() {
        this.sportIds = [];
        this.tags = [];
        this.dates = {};
    }
    setSportIds(sportIds) {
        this.sportIds = [...this.sportIds, ...sportIds];
    }
    setDates(sportIds, date) {
        sportIds.forEach(sportId => {
            !this.dates[sportId] && (this.dates[sportId] = []);
            this.dates[sportId].push(date);
        });
    }
    setTags(tag) {
        this.tags.push(tag);
    }
    /**
     * Clear all loaded data
     */
    clearData() {
        this.sportIds = [];
        this.tags = [];
        this.dates = {};
    }
    /**
     * Check if current sport ids were already loaded
     * @param {string[]} sportIds current ids
     * @returns {boolean}
     */
    containsSportIds(sportIds) {
        return sportIds.every(id => this.sportIds.indexOf(id) !== -1);
    }
    /**
     * Check if current date was already loaded
     * @param {number} date current date
     * @returns {boolean}
     */
    containsDate(sportId, date) {
        return this.dates[sportId] && this.dates[sportId].indexOf(date) !== -1;
    }
    /**
     * Check if current date & sport ids were already loaded
     * @param {string[]} sportIds current ids
     * @param {number} date current date
     * @returns {boolean}
     */
    containsSportIdsAndDate(sportIds, date) {
        return sportIds.every(sportId => this.containsDate(sportId, date.getDate()));
    }
    /**
     * Check if current tag was already loaded
     * @param {EventsBySportIdRequest.EventTagsEnum} tag current tag
     * @returns {boolean}
     */
    containsTag(tag) {
        return this.tags.indexOf(tag) !== -1;
    }
    /**
     * If there is sport, which was not loaded until now add it
     * and return true, else - false
     * @param {string[]} sportIds- current sport ids
     * @returns {boolean}
     */
    updateSports(sportIds) {
        if (!this.containsSportIds(sportIds)) {
            this.setSportIds(sportIds);
            return true;
        }
        return false;
    }
    /**
     * If there is date, which was not loaded until now add it
     * and return true, else - false
     * @param {Date} date- current date
     * @returns {boolean}
     */
    updateDates(sportIds, date) {
        if (!this.containsSportIdsAndDate(sportIds, date)) {
            this.setDates(sportIds, date.getDate());
            return true;
        }
        return false;
    }
    /**
     * If there is tag, which was not loaded until now add it
     * and return true, else - false
     * @param {EventsBySportIdRequest.EventTagsEnum} tag - current tag
     * @returns {boolean}
     */
    updateTags(tag) {
        if (!this.containsTag(tag)) {
            this.setTags(tag);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=LoadedData.js.map